import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const rows = [{
  before: '😩 Semanas muertas esperando un cliente que no regatee',
  after: '✅ −90% tiempo muerto. Fabrica hoy, vende mañana.'
}, {
  before: '🔄 Miedo a que 50€ sea "caro" por una pieza',
  after: '✅ Confianza total. Vendes diseño y utilidad.'
}, {
  before: '📉 Retales en la basura. Dinero tirado.',
  after: '✅ Tus sobras se convierten en 45-80€.'
}, {
  before: '💼 "Soy el apañao de los recados"',
  after: '✅ "Tengo mi marca de artesanía online."'
}];
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-204" data-mp="26m8xubk459qx">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-205" data-mp="21o7hhye2noj5">
        <SectionTag icon="⚡" data-id="element-206" data-mp="2z4ealvz6ak3q">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-207" data-mp="2z5z3zi9r3x00">
          Tu semana no debería terminar con el taller lleno de serrín e incertidumbre...
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-208" data-mp="15a9dnbfpswtg">
          Un domingo por la tarde, viendo ese tablero que te sobró o esas herramientas que costaron un
          dinero y no se pagan solas. Miedo a fabricar algo y que se quede cogiendo polvo porque "nadie lo
          quiere".
        </p>

        <div className="mt-6 rounded-2xl border border-brown/25 bg-brown/5 p-5 text-left sm:p-6" data-id="element-209" data-mp="mhoni1reh5tc">
          <p className="font-heading text-sm font-bold uppercase tracking-wide text-brown" data-id="element-210" data-mp="rgru3qn13k3f">
            Recupera la rentabilidad de tu ingenio
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-211" data-mp="dil4exs8gqeu">
            <span className="font-semibold text-ink" data-id="element-212" data-mp="hjn5lk5pncjg">El coste real:</span> Intentar vender muebles grandes o
            esperar a que te salga una "chapuza" de reforma te quita tiempo y salud. Es hora de fabricar
            objetos que la gente desea regalar.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-213" data-mp="3kuml1ji1gv7m">
        <p className="mb-4 text-center font-heading text-sm font-bold uppercase tracking-wide text-muted" data-id="element-214" data-mp="3fugopq0tqkj7">
          Las 4 Transformaciones
        </p>
        <ScrollHintTable minWidth="600px" data-id="element-215" data-mp="3btofuxvv6hng">
          <table className="w-full text-left text-sm" data-id="element-216" data-mp="36tsaovbfkk6b">
            <thead data-id="element-217" data-mp="36v3n1jixz091">
              <tr className="border-b border-brown/15 bg-brown/5 text-xs uppercase tracking-wide text-muted" data-id="element-218" data-mp="36vvag72dxro8">
                <th className="px-5 py-3 font-semibold" data-id="element-219" data-mp="7ghvgw58ld9e">Antes</th>
                <th className="px-5 py-3 font-semibold" data-id="element-220" data-mp="3ed649ltn2sk">Ahora</th>
              </tr>
            </thead>
            <tbody data-id="element-221" data-mp="3uq6e7y57xfso">
              {rows.map((row, i) => <m.tr key={row.before} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.08
            }} className={i !== rows.length - 1 ? 'border-b border-brown/10' : ''} data-id="element-222" data-mp="3pso3c27n4qi1" data-mpi={i}>
                  <td className="px-5 py-4 align-top leading-relaxed text-muted" data-id="element-223" data-mp="ym5n0g5jza8n">{row.before}</td>
                  <td className="px-5 py-4 align-top leading-relaxed text-ink" data-id="element-224" data-mp="13l9t2xx6krur">{row.after}</td>
                </m.tr>)}
            </tbody>
          </table>
        </ScrollHintTable>
      </div>
    </section>;
}